export class PrescriptionFormType {
  slug: string;
  nom: string;

  constructor(slug: string, nom: string) {
    this.slug = slug;
    this.nom = nom;
  }

  static factory(
    basePrescriptionAPI: PrescriptionFormTypeAPI,
  ): PrescriptionFormType {
    return new PrescriptionFormType(
      basePrescriptionAPI.slug,
      basePrescriptionAPI.name,
    );
  }
}

export type PrescriptionFormTypeAPI = {
  slug: string;
  name: string;
};
